import Moment from 'moment'
import marked from 'marked'

let filter = {

  wordDict: (value = '') => window.wordDict[value],

  multilang: (value = {}) => value?(window.lang == 'en'? value.en : (value.zh_hant || value.en)):'',

  // remove html tag
  removeTag: (value = '') => value.replace(/(<([^>]+)>)/ig,""),

  img: (url = '', size = 0, param = '') => {
    return url? `${url.replace(/^http[s]?:/, '')}=s${size}${param}`: ''
  },

  image: (id, dir = '', type = '') => `/images/${dir}/${id}/${type}.jpg`,

  resource: (resource = {}) => {
    if (!_.isNull(resource)) {
      // console.log(resource.url)
      return resource.url!=null? resource.url: resource.download_url
    } else {
      return ''
    }
  },

  bgImage: (url, otherStyle = {}) => {
    return _.extend({
      backgroundImage: `url(${url}=s0)`,
    }, otherStyle)
  },

  link: (path) => {
    return {
      path,
    }
  },

  safe: string => {
    return string
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'")
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&amp;/g, '&')
  },

  slug: string => encodeURI(string.toLowerCase().replace(/\s/, '-')),


  moment: (timestamp, format = 'lll') => Moment(timestamp, 'x').format(format),

  momentCompare: (timestamp) => Moment(timestamp, 'x').to(),

  markdown: (content) => marked(content, {sanitize: true}),

  // url
  teamDetailUrl: (team = {}, selected='partner') => `/about/team/${selected}/${team.people_id}/${team.name.en}`,
  companyDetailUrl: (company = {}, category = 'all') => `/portfolio/${category}/${company.company_id}/${company.name.en}`,
  socialCompanyDetailUrl: (company = {}) => `/about/social-responsibility-projects/${company.company_id}/${company.name.en}`,
}

export default filter



// WEBPACK FOOTER //
// ./assets/filter.js